import { render, staticRenderFns } from "./TableComponentProducts.vue?vue&type=template&id=b28f3e28&scoped=true"
import script from "./TableComponentProducts.vue?vue&type=script&lang=js"
export * from "./TableComponentProducts.vue?vue&type=script&lang=js"
import style0 from "./TableComponentProducts.vue?vue&type=style&index=0&id=b28f3e28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28f3e28",
  null
  
)

export default component.exports